export default __webpack_public_path__ + "public/assets/images/868da2bc8bd7513b565ec410b38ad5dc.png";